// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"06c64db7","4":"3b3a72aa","51":"57c9357a","167":"83b29b5a","262":"57c9357a","378":"57c9357a","616":"e947f77d","707":"e16985cb","770":"1ace0c20","783":"ebf86ef9","901":"3ce6c3b1","988":"b19cea11"}[chunkId] + ".chunk.css";
};